/**
 * Returns the rel attribute value for a link based on its sponsorship status and target.
 * @param {boolean} isSponsored - whether the link is sponsored
 * @param {boolean} isTargetNew - whether the link opens in a new tab
 * @returns {string|undefined}
 */

export function getRelAttribute(isSponsored, isTargetNew) {
  if (isSponsored && isTargetNew) {
    return 'nofollow noopener noreferrer';
  } else if (isSponsored) {
    return 'nofollow';
  } else if (isTargetNew) {
    return 'noopener noreferrer';
  }
  return undefined;
}
